// front-end/src/components/block-system/block-configs/index.js - UPDATED VERSION с course-card

import {createDiagnosticCard, diagnosticCardProps} from './block-types/diagnostic-card';
import {accordionItemProps, createAccordionItem} from './block-types/accordion-item';
import {createDoctorCard, doctorCardProps} from "./block-types/doctor-card";
import {createNewsBlock, newsBlockProps} from "./block-types/news-block";
import {contentParagraphProps, createContentParagraph} from "./block-types/content-paragraph";
import {contentImageProps, createContentImage} from "./block-types/content-image";
import {caseCardProps, createCaseCard} from "./block-types/case-card";
import {certificateBlockProps, createCertificateBlock} from "./block-types/certificate-block";
import {createVacancyBlock, vacancyBlockProps} from "./block-types/vacancy-block";
import {courseModuleProps, createCourseModule} from "./block-types/course-module";
import {courseCardProps, createCourseCard} from "./block-types/course-card";
import {createExpertiseCard, expertiseCardProps} from './block-types/expertise-card';

export const blockCreators = {
    'cards-book': {
        'diagnostic-card': createDiagnosticCard
    },
    'accordion-cases': {
        'case': createAccordionItem
    },
    'work-process-accordion': {
        'case': createAccordionItem
    },
    'doctors-block': {
        'doctor-card': createDoctorCard
    },
    'news-section': {
        'news-block': createNewsBlock
    },
    'news-section-1': {
        'news-block': createNewsBlock
    },
    'news-content': {
        'content-paragraph': createContentParagraph,
        'content-image': createContentImage
    },
    'diagnostic-content': {
        'content-paragraph': createContentParagraph,
        'content-image': createContentImage
    },
    'cases-section': {
        'case-card': createCaseCard
    },
    'certificates-section': {
        'certificate-block': createCertificateBlock
    },
    'vacancies-section': {
        'vacancy-block': createVacancyBlock
    },
    'course-modules-section': {
        'course-module': createCourseModule
    },
    'courses-section': {
        'course-card': createCourseCard
    },
    'expertises-section': {
        'expertise-card': createExpertiseCard
    }
};

export const blockDefinitions = {
    'diagnostic-card': diagnosticCardProps,
    'case': accordionItemProps,
    'doctor-card': doctorCardProps,
    'news-block': newsBlockProps,
    'content-paragraph': contentParagraphProps,
    'content-image': contentImageProps,
    'case-card': caseCardProps,
    'certificate-block': certificateBlockProps,
    'vacancy-block': vacancyBlockProps,
    'course-module': courseModuleProps,
    'course-card': courseCardProps,
    'expertise-card': expertiseCardProps
};

// Остальные функции остаются без изменений...
export function getBaseType(typeId) {
    const match = typeId.match(/^([a-zA-Z-]+)(-\d+)?$/);
    return match ? match[1] : typeId;
}

export function getBlockCreator(parentType, blockType) {
    const baseParentType = getBaseType(parentType);

    if (!blockCreators[baseParentType] || !blockCreators[baseParentType][blockType]) {
        return null;
    }
    return blockCreators[baseParentType][blockType];
}

export function getAvailableBlockTypes(parentType) {
    const baseParentType = getBaseType(parentType);

    if (!blockCreators[baseParentType]) {
        return [];
    }
    return Object.keys(blockCreators[baseParentType]);
}

export function getBlockDefinition(blockType) {
    return blockDefinitions[blockType] || null;
}

export function canAddBlockToParent(parentType, blockType) {
    const definition = getBlockDefinition(blockType);
    if (!definition || !definition.allowedParents) {
        return false;
    }

    const baseParentType = getBaseType(parentType);
    return definition.allowedParents.includes(baseParentType);
}

export function blockRequiresPage(blockType) {
    const definition = getBlockDefinition(blockType);
    return definition && definition.requiresPage === true;
}

export function validateBlockPageContext(blockType, sectionElement) {
    if (!blockRequiresPage(blockType)) {
        return {valid: true, pageTitle: null};
    }

    const sectionId = sectionElement.id || sectionElement.getAttribute('class');
    const baseType = getBaseType(sectionId);

    if (baseType === 'news-content') {
        const path = window.location.pathname;

        // Clean URL: /news/{slug}
        const newsMatch = path.match(/^\/news\/([^/]+)/);
        if (newsMatch) return {valid: true, pageTitle: newsMatch[1]};

        // Clean URL: /case/{slug}
        const caseMatch = path.match(/^\/case\/([^/]+)/);
        if (caseMatch) return {valid: true, pageTitle: caseMatch[1]};

        // Legacy URL: /News.html?slug=X
        if (path.match(/\/News(\.html)?$/)) {
            const slug = new URLSearchParams(window.location.search).get('slug');
            if (slug) return {valid: true, pageTitle: slug};
        }

        let parent = sectionElement.parentElement;
        while (parent) {
            const newsBlock = parent.querySelector('[data-block-name^="news-block-"]');
            if (newsBlock) {
                const newsSlug = newsBlock.getAttribute('data-news-slug') || newsBlock.getAttribute('data-block-name');
                return {valid: true, pageTitle: newsSlug};
            }
            parent = parent.parentElement;
        }

        return {valid: false, error: 'No news context found for content block'};
    }

    // НОВОЕ: Валидация для course-modules-section
    if (baseType === 'course-modules-section') {
        if (window.location.pathname.match(/course-detail(\.html)?$/)) {
            const urlParams = new URLSearchParams(window.location.search);
            const courseSlug = urlParams.get('slug');

            if (courseSlug) {
                return {valid: true, pageTitle: courseSlug};
            }
        }

        // Проверяем data-page у body
        const bodyPage = document.body.getAttribute('data-page');
        if (bodyPage && bodyPage.startsWith('Course - ')) {
            const courseSlug = bodyPage.replace('Course - ', '');
            return {valid: true, pageTitle: courseSlug};
        }

        return {valid: false, error: 'No course context found for module block'};
    }

    return {valid: true, pageTitle: null};
}

export function registerBlockType(blockType, definition, creator, parentTypes) {
    if (typeof creator !== 'function') {
        return;
    }

    if (!Array.isArray(parentTypes) || !parentTypes.length) {
        return;
    }

    blockDefinitions[blockType] = definition;

    parentTypes.forEach(parentType => {
        if (!blockCreators[parentType]) {
            blockCreators[parentType] = {};
        }
        blockCreators[parentType][blockType] = creator;
    });
}

export function registerParentType(parentType) {
    if (!blockCreators[parentType]) {
        blockCreators[parentType] = {};
        return true;
    }
    return false;
}

export const blockConfigsAPI = {
    getBaseType,
    getBlockCreator,
    getAvailableBlockTypes,
    getBlockDefinition,
    canAddBlockToParent,
    blockRequiresPage,
    validateBlockPageContext,
    registerBlockType,
    registerParentType
};